import * as React from "react";
import { styled } from "@mui/system";
import MUILink from "@mui/material/Link";
import { LinkProps as LinkPropsMUI } from "@mui/material/Link";
export interface LinkProps extends LinkPropsMUI {
  component?: React.ElementType;
}

export const Link: (props: LinkProps) => JSX.Element = styled(
  React.forwardRef<HTMLAnchorElement, LinkProps>((props, ref) => (
    <MUILink ref={ref} {...props} />
  )),
  {
    name: "Link",
    slot: "Root",
    overridesResolver: (props, styles) => []
  }
)(({ theme }) => ({
  "&.MuiLink-root": {
    cursor: "pointer"
  }
}));
